import { requestApiV2 } from '@library'
import { T3CConfig, QueueInfo, T3CSkillGroup } from '@types'

export function getT3cSdkUrl (payload?: { refresh: boolean }) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/CreateLoginToken', payload)
}

export function addT3CConfig (payload: T3CConfig) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/CreateBizT3CApp', payload)
}

export function getT3CConfig () {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/GetBizT3CApp')
}

export function editT3CConfig (payload: T3CConfig) {
  return requestApiV2('/trpc.tcc.tcc_main.T3C/UpdateBizT3CApp', payload)
}

export function getCallDuration (payload?: { startTime?: string; endTime?: string }) {
  return requestApiV2<{ callDuration: number; callTime: number }>('/trpc.tcc.tcc_main.Call/GetT3CSalesCallInfo', payload)
}

export function getIncomingQueueCount (payload?: { skillGroupIds?: number[] }) {
  return requestApiV2<QueueInfo>('/trpc.tcc.tcc_main.Call/GetSkillGroupQueueCount', payload)
}

export function getSalesT3CSkillGroup () {
  return requestApiV2<{skillGroups: T3CSkillGroup[]}>('trpc.tcc.tcc_main.Call/GetSalesT3CSkillGroup')
}

/**
 * 通过sessionId获取原始主叫号码
 * 用于400热线meeting来源场景，获取实际的来电号码
 */
export function getT3CCallInRecordCallerBySessionId (payload: { sessionId: string }) {
  return requestApiV2<{ caller: string }>('/trpc.tcc.tcc_main.Call/GetT3CCallInRecordCallerBySessionId', payload)
}

/**
 * 提交实时 ASR 通话文本（通话挂断后调用）
 * 后端接收后存储并触发 AI 智能小结
 * @param payload.recordId 通话记录 ID（CreateCallRecord 返回）
 * @param payload.sessionId T3C 会话 ID
 * @param payload.content 完整通话文本，格式 "角色：内容\n角色：内容"
 * @param payload.conversation 结构化对话 JSON 字符串
 * @param payload.duration 本次通话时长（单位：秒，未接通传 0）
 * @returns status: 0=已接收并触发小结, 1=重复提交（幂等）
 */
export function submitRealtimeAsr (payload: {
  recordId: number
  sessionId: string
  content: string
  conversation: string
  duration: number
}) {
  return requestApiV2<{ status: number }>('/trpc.tcc.tcc_main.Call/SubmitRealtimeAsr', payload)
}
